/**
 * PostComments 骨架屏组件
 *
 * CLS 优化：为评论列表区域提供布局稳定的骨架屏
 *
 * 问题：切换帖子时，评论数据加载过程中只显示 Spin，容器高度变化导致 CLS
 *
 * 解决：在 initialLoading 时显示与 PostComments 布局一致的骨架屏，保持容器高度稳定
 */
import { Skeleton } from 'antd';

interface PostCommentsSkeletonProps {
  /** 是否显示移动端预览模式（简化版） */
  isMobilePreview?: boolean;
  /** 显示的骨架项数量 */
  itemCount?: number;
}

export default function PostCommentsSkeleton({ isMobilePreview = false, itemCount = 6 }: PostCommentsSkeletonProps) {
  return (
    <div className="w-full flex flex-col h-full">
      {/* 标题和搜索框骨架 */}
      <div className="p-4 max-md:p-0 max-md:pb-2.5">
        <div className="flex flex-col gap-2">
          {/* 标题：{totalComments} Comments */}
          <Skeleton.Input active style={{ width: 100, height: 24 }} />

          {!isMobilePreview && (
            /* 搜索框 */
            <div>
              <Skeleton.Input active style={{ width: '100%', height: 36, borderRadius: 8 }} />
            </div>
          )}
        </div>
      </div>

      {/* 评论列表骨架 */}
      <div className="flex-1 overflow-hidden">
        {Array.from({ length: itemCount }, (_, index) => (
          <div key={index} className="p-4 max-md:px-0 max-md:py-2.5">
            <div className="flex items-start gap-3">
              {/* 用户头像 */}
              <Skeleton.Avatar active size={40} />

              {/* 评论内容 */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-col gap-1.5">
                  {/* 用户名和时间 */}
                  <div className="flex items-center gap-2">
                    <Skeleton.Input active style={{ width: 100, height: 16 }} />
                    <Skeleton.Input active style={{ width: 80, height: 14 }} />
                  </div>
                  {/* 评论文本 - 两行 */}
                  <Skeleton.Input active style={{ width: '100%', height: 16 }} />
                  <Skeleton.Input active style={{ width: '70%', height: 16 }} />
                  {/* 点赞和回复数 */}
                  <div className="flex items-center gap-4 mt-1">
                    <Skeleton.Input active style={{ width: 50, height: 14 }} />
                    <Skeleton.Input active style={{ width: 50, height: 14 }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
